import React from 'react';
import { Select, Pagination, PaginationProps } from '@ver-uds/uswds-react';
import PaginationGoToPage from './PaginationGoToPage';

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

const goToPageFormIdDefault = 'go-to-page-input';

export interface PaginationV2Props {
  pageCount: number;
  gotoPage: (pageIndex: number) => void;
  setPageSize: (pageSize: number) => void;
  pageIndex: number;
  pageSize: number;
  pageSizeOptions?: Array<number>;
  goToPageFormId?: string;
  enableGoToPage?: boolean;
}

const ItemLinkButton: PaginationProps['itemLink'] = ({ children, ...rest }) => (
  <button
    type="button"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    {children}
  </button>
);

const PaginationV2 = ({
  pageCount,
  gotoPage,
  setPageSize,
  pageIndex,
  pageSize,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  goToPageFormId = goToPageFormIdDefault,
  enableGoToPage = false,
}: PaginationV2Props): JSX.Element => {
  return (
    <div className="ver-pagination">
      <div className="ver-pagination__rows-per-page">
        <span className="ver-pagination__text">Rows Per Page</span>
        <Select
          className="ver-pagination__selector"
          id="row-count-selector"
          aria-label="Rows per Page Selector"
          value={pageSize}
          onChange={(event): void => setPageSize(parseInt(event.target.value, 10))}
        >
          {pageSizeOptions.map((pageSizeOption) => (
            <option value={pageSizeOption} key={pageSizeOption}>
              {pageSizeOption}
            </option>
          ))}
        </Select>
      </div>
      <Pagination current={pageIndex} items={pageCount} itemLink={ItemLinkButton} itemOnClick={gotoPage} />
      {enableGoToPage && (
        <PaginationGoToPage
          goToPageFormId={goToPageFormId}
          gotoPage={gotoPage}
          pageCount={pageCount}
          pageIndex={pageIndex}
        />
      )}
    </div>
  );
};

export default PaginationV2;
